import request from '@/utils/request';

/*
 * Created: 2019-05-23 10:05:47
 * Author : zc
 * Email : 591074801@qq.com
 * -----
 * Description: 表单验证规则
 */

/**通用正则规则 */
export const regRule = function (reg: any, message: string) {
  return (v: any) => {
    if (reg.test(v)) {
      return true;
    } else {
      return message;
    }
  };
};

/**非空验证 */
export const emptyRule = function (name: string) {
  return (v: any) => !!(v && v.trim()) || `${name}不能为空`;
};
/**选择非空验证 */
export const selectEmptyRule = function (name: string) {
  return (v: any) => !!v || `${name}不能为空`;
};
/**选择非空验证 */
export const selectListEmptyRule = function (name: string) {
  return (v: any) => v.length > 0 || `${name}不能为空`;
};
/**范围判断 实例：等级折扣不能小于28% */
export const rangeRule = function (min: number, max: number, unit: string, name: string) {
  return (v: any) => {
    if (v < min) {
      return `${name}不能小于${min}${unit}`;
    } else if (v > max) {
      return `${name}不能大于${max}${unit}`;
    } else {
      return true;
    }
  };
};

/**长度范围判断 实例：等级折扣不能小于28% */
export const rangeLengthRule = function (min: number, max: number, name: string) {
  return (v: any) => {
    if (!v){
      return `${name}不能小于${min}位,不能大于${max}位`
    }
    else if (v.length < min) {
      return `${name}不能小于${min}位`;
    } else if (v.length > max) {
      return `${name}不能大于${max}位`;
    } else {
      return true;
    }
  };
};

/**判断两个值是否相等 */
export const equalRule = function (v1: any, v2: any, message: string) {
  return (v: any) => {
    if (v1 != v2) {
      return message;
    } else {
      return true;
    }
  };
};

/**特殊字符 */
export const specialCharRule = (v: any, message?: any) => {
  if (/[^\u4e00-\u9fa5a-zA-Z0-9\w]/g.test(v)) {
    return message ? message : '不能包含特殊字符';
  } else {
    return true;
  }
};

/**密码规则 */
export const pwdRule = (v: any) => {
  if (/^[a-zA-Z0-9]{6,16}$/.test(v)) {
    return true;
  } else {
    return '6-16位,字母或者数字组合';
  }
};

/**折扣规则  只能数字和小数点,小数点后保留两位*/
export const discountRule = (v: any) => {
  if (v.match(/^\d*(\.?\d{0,2})/g)) {
    return true;
  } else {
    return '只能数字和小数点,小数点后保留两位';
  }
};

/**手机号规则  只能11位数字*/
export const telRule = function () {
  return (v: any) => {
    if (v && /^1[3-9][0-9]{9}$/.test(v)) {
      return true;
    } else {
      return '手机号格式不正确';
    }
  };
};
/**电话规则  只能12位数字*/
export const phoneRule = function () {
  return (v: any) => {
    if (!v) return true;
    if (v && /^\d*$/.test(v)) {
      return true;
    } else {
      return '请输入正确的电话格式';
    }
  };
};
